/* eslint-disable @typescript-eslint/no-explicit-any */
export interface ImageFormatComponent {
  url: string
  name: string
  width: number
  height: number
  mime: string
  formats?: {
    large: ImageFormatComponent
    medium: ImageFormatComponent
    small: ImageFormatComponent
    thumbnail: ImageFormatComponent
  }
}

export default interface ImageComponent extends ImageFormatComponent {
  alternativeText: string
  caption: string
}

export const toImageComponent = (response: any): ImageComponent | null => {
  const data = response || null
  if (!data) return null

  const res: ImageComponent = {
    url: data.url,
    name: data.name,
    width: data.width,
    height: data.height,
    mime: data.mime,
    alternativeText: data.alternativeText,
    caption: data.caption,
  }

  if (data.formats && data.formats.large && data.formats.medium && data.formats.small && data.formats.thumbnail) {
    const large = data.formats.large
    const medium = data.formats.medium
    const small = data.formats.small
    const thumbnail = data.formats.thumbnail

    res.formats = {
      large: {
        url: large.url,
        name: large.name,
        width: large.width,
        height: large.height,
        mime: large.mime,
      },
      medium: {
        url: medium.url,
        name: medium.name,
        width: medium.width,
        height: medium.height,
        mime: medium.mime,
      },
      small: {
        url: small.url,
        name: small.name,
        width: small.width,
        height: small.height,
        mime: small.mime,
      },
      thumbnail: {
        url: thumbnail.url,
        name: thumbnail.name,
        width: thumbnail.width,
        height: thumbnail.height,
        mime: thumbnail.mime,
      },
    }
  }

  return res
}
